import React from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { MdDelete, MdEdit } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
import MobileContactMenu from "../MobileContactMenu";

const UserCard = ({
  user,
  serialNumber,
  onHoldUser,
  onChangePlan,
   onDeleteUser,
}) => {

  return (
    <div className="relative min-w-0 rounded-xl border bg-white p-4 shadow-md">

      {serialNumber != null && (
        <span className="absolute right-3 top-3 rounded-full bg-purple-100 px-2.5 py-1 text-xs font-bold text-purple">
          #{serialNumber}
        </span>
      )}


      {/* User Header */}
      <div className="mb-4 flex min-w-0 items-center gap-3 pr-10">


        <div className="w-12 h-12 rounded-full bg-purple text-white flex items-center justify-center font-bold text-lg">
          {user?.name
            ? user.name.charAt(0).toUpperCase()
            : "U"}
        </div>


        <div className="min-w-0 overflow-hidden">

          {user?._id ? (
            <Link
              to={`/dash/view-user/${user._id}`}
              className="block font-semibold text-gray-800 truncate hover:underline"
            >
              {user?.name || "User Deleted"}
            </Link>
          ) : (
            <h3 className="font-semibold text-gray-800 truncate">
              {user?.name || "User Deleted"}
            </h3>
          )}


          <p className="text-sm text-gray-500 truncate">
            {user?.email || "-"}
          </p>

        </div>


      </div>





      {/* Details */}

      <div className="grid grid-cols-2 gap-x-3 gap-y-4 text-sm">


        <Info
          title="Plan"
          value={user?.planName || "-"}
        />


        <Info
          title="Platform"
          value={user?.platform || "-"}
        />


        <Info
          title="Amount Paid"
          value={`₹ ${user?.amount || 0}`}
        />


        <Info
          title="Remaining"
          value={`₹ ${Math.ceil(user?.remaining || 0)}`}
        />


        <Info
          title="Total Earning"
          value={`₹ ${Math.ceil(
            user?.unifiedWallet?.balance || 0
          )}`}
        />


        <Info
          title="Locked Balance"
          value={`₹ ${Math.ceil(
            user?.unifiedWallet?.lockedBalance || 0
          )}`}
        />


        <Info
          title="Created On"
          value={
            user?.createdOn
              ? dayjs(user.createdOn)
                  .format("D MMM YYYY h:mm A")
              : "-"
          }
        />
        <Info
          title="Mobile No."
          value={
            <MobileContactMenu mobile={user?.mobile} />
          }
        />


      </div>






      {/* Quiz Stats */}

      <div className="mt-4 flex justify-around bg-gray-50 rounded-lg p-3">


        <Stat
          value={user?.quizStats?.totalRight || 0}
          label="Right"
          color="text-green-600"
        />


        <Stat
          value={user?.quizStats?.totalWrong || 0}
          label="Wrong"
          color="text-red-500"
        />


        <Stat
          value={user?.quizStats?.totalSkipped || 0}
          label="Skip"
          color="text-yellow-500"
        />


      </div>






      {/* Action */}

     <div className="mt-4 grid grid-cols-2 gap-2">

  <Link
    to={`/dash/view-user/${user?._id}`}
    className="rounded-lg bg-purple py-2 text-center text-white"
  >
    View
  </Link>

  <Link
    to={`/dash/edit-user/${user?._id}`}
    className="rounded-lg bg-blue-600 py-2 text-center text-white flex items-center justify-center gap-2"
  >
    <MdEdit />
    Edit
  </Link>

  <button
    onClick={() => onHoldUser(user)}
    className="rounded-lg bg-yellow-500 py-2 text-white flex items-center justify-center gap-2"
  >
    <HiStatusOnline />
    Hold User
  </button>

  <button
    onClick={() => onChangePlan(user)}
    className="rounded-lg bg-green-600 py-2 text-white flex items-center justify-center gap-2"
  >
    <GrOverview />
    Change Plan
  </button>

   <button
    onClick={() => onDeleteUser(user)}
    className="col-span-2 rounded-lg bg-red-600 py-2 text-white flex items-center justify-center gap-2 hover:bg-red-700"
  >
    <MdDelete />
    Delete User
  </button>

</div>


    </div>
  );
};





const Info = ({title,value}) => (

  <div>
    <p className="text-gray-500 text-xs">
      {title}
    </p>

    <p className="font-semibold text-gray-800 truncate">
      {value}
    </p>
  </div>

);





const Stat = ({value,label,color}) => (

  <div className="text-center">

    <p className={`font-bold text-lg ${color}`}>
      {value}
    </p>

    <span className="text-xs text-gray-500">
      {label}
    </span>

  </div>

);



export default UserCard;
